import Vue from 'vue'
import { GET_COUNTRIES, ERROR_XHR } from '../mutation-types.js'

export const getCountries = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('country')
    .then(
      (response) => {
        dispatch(GET_COUNTRIES, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/countriesActions.js